<template>
  <ul
    v-if="children"
    class="submenu">
    <li
      class="relative submenu-item"
      :key="link.slug"
      v-for="link in children"
      :class="{
        'with-submenu': link.children_data && link.children_data.length
      }"
      @mouseenter="activeSubMenu = link.id"
      @mouseleave="activeSubMenu = null"
    >
      <router-link
        class="menu-link"
        :class="{ active: activeSubMenu == link.id }"
        :to="
          localizedRoute({
            name: 'category',
            params: { id: link.id, slug: link.url_path }
          })
        "
      >
        {{ link.name }}
      </router-link>
      <sub-category
        v-show="activeSubMenu === link.id"
        :category-links="link.children_data"
        :id="link.id"
        v-if="link.children_count > 0"
        :parent-slug="link.slug"
        :parent-name="link.name"
        class=""
      />
    </li>
  </ul>
</template>
<script>
export default {
  name: 'SubCategory',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    parentSlug: {
      type: String,
      required: false,
      default: ''
    },
    categoryLinks: {
      type: null,
      required: false,
      default: false
    },
    parentName: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      activeSubMenu: null
    };
  },
  computed: {
    children () {
      if (this.id === 'categoryMenu') {
        const result = this.categoryLinks;
        return result;
      }

      if (
        !this.$store.state.config.entities.category.categoriesDynamicPrefetch &&
        this.categoryLinks &&
        this.categoryLinks.length > 0 &&
        this.categoryLinks[0].name
      ) {
        // we're using dynamic prefetching and getting just category.children_data.id from 1.7
        const result = this.categoryLinks;
        return result;
      } else {
        const result = this.$store.state.category.list.filter(c => {
          return c.parent_id === this.id;
        }); // return my child categories
        return result;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.submenu {
  z-index: 1000;
  position: absolute;
  background: #f0047f;
  list-style: none;
  padding: 0px 0px;
  margin: 0px;
  width: 300px;
  box-shadow: 1px 3px 3px rgba(#000, 0.1);
  .submenu-item {
    border-bottom: solid 1px #bb4582;
    display: block;
    cursor: pointer;
    transition: all 0.1s ease-in;
    .menu-link {
      color: #fff;
      font-size: 14px;
      display: block;
      padding: 10px 20px;
    }
    &:hover {
      background: #bb4582;
      box-shadow: 0px 3px 3px rgba(#000, 0.1);
    }
  }
  .submenu {
    background: #f0047f;
    position: absolute;
    left: 100%;
    top: 0px;
    .submenu-item {
      // border-bottom: solid 1px rgba(#fff, 0.5);
      border-bottom: solid 1px #bb4582;

      &:hover {
        background: #bb4582;
        .menu-link {
          color: #fff;
        }
      }
    }
    .submenu {
      background: #f0047f;
      max-height: 70vh;
      overflow-x: hidden;
      overflow-y: auto;

      .submenu-item {
        &:hover {
          background: none;
          box-shadow: none;
          .menu-link {
            color: #fff;
          }
        }
      }
    }

    &.overflow-enable {
      max-height: 60vh;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>
